
namespace GeniuzPOS.PosShift {

    @Serenity.Decorators.registerClass()
    export class ReportVatRefundGrid extends Serenity.EntityGrid<ReportVatRefundRow, any> {
        protected getColumnsKey() { return ReportVatRefundColumns.columnsKey; }
        protected getDialogType() { return ReportVatRefundDialog; }
        protected getIdProperty() { return ReportVatRefundRow.idProperty; }
        protected getInsertPermission() { return ReportVatRefundRow.insertPermission; }
        protected getLocalTextPrefix() { return ReportVatRefundRow.localTextPrefix; }
        protected getService() { return ReportVatRefundService.baseUrl; }

        public mn: string;
        public year: string;
        public shop: string;

        constructor(container: JQuery) {
            super(container);
            let qryrow = Q.tryFirst(QRreport.QRywcSpecRow.getLookup().items, x => x.Id == 134)

            this.mn = Q.formatDate(qryrow.DateBegin, 'dd/MM/yyyy');
            this.year = Q.formatDate(qryrow.DateEnd, 'dd/MM/yyyy');
            this.shop = qryrow.ShopId ?? "";
            console.log(this.mn + ' ' + this.year + ' ' + this.shop)
        }



        protected getButtons() {
            var buttons = super.getButtons();

            // remove first button (Add button)
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            // buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'column-picker-button'), 1)

            // Add buttons import excel, pdf //Erorr 
            buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: ReportVatRefundService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));
                

            buttons.push(
                {
                    title: Q.text("PDf"), // *** Get button text from translation
                    cssClass: '.panel-pdf',
                    icon: 'fa fa-file-pdf-o',
                    onClick: () => {
                        
                        const request = this.getView().params as ReportVatRefundData;
                    
                        request.DatetoDate = "วันที่ " + this.mn + " ถึง " + this.year;
                        let Para = Q.tryFirst(Administration.CsParaRow.getLookup().items, x => x.Id == 1)
                        request.BizName = Para.TaxInvName;
                        
                        if (!Q.isEmptyOrNull(this.shop)) {
                            let Shop = Q.tryFirst(InitialData.PsShopRow.getLookup().items, x => x.ShopId == this.shop)
                            request.ShopName = Shop.ShopRegName;
                            request.ShopTaxId = Shop.ShopTaxId;
                            request.ShopAddress = Shop.ShopRegAddressLine1 + " " + Shop.ShopRegAddressLine2 + " " + Shop.ShopRegAddressLine3;
                            request.BranchName = Shop.BranchName;
    
                        }else{
                            request.ShopName = Para.TaxInvName;
                            request.ShopTaxId = Para.TaxId;
                            request.ShopAddress = Para.TaxInvAddrLine1 + " " + Para.TaxInvAddrLine2 + " " + Para.TaxInvAddrLine3;
                            request.BranchName = "ทุกสาขา";
                          
                        }
                        
                        request.Details = this.view.getRows();
                        var userId = Q.first(Administration.UserRow.getLookup().items, x => x.ShopId == Authorization.userDefinition.ShopId);
                        request.user = userId.Username;
                        request.username = userId.DisplayName;
                        console.log(request.Details)
                        console.log(request)

                        Q.postToService({ service: this.getService() + '/ExportPdf', request: request, target: '_blank' })
                        // GeniuzPOS.Purchase.PoCNRTVService.GetNextNumber

                    },

                }
            );

            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/QRreport/QRywcSpec#QRreport.QRywcSpec1301/edit/134';
                        return false;
                    },
                }
            );


            return buttons;
        }

        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            // need to turn grouping panel ON for drag drop grouping to work properly
            opt.groupingPanel = true;
            return opt;
        }

        protected createSlickGrid() {
            var grid = super.createSlickGrid();          

            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());
            
            this.view.setSummaryOptions({
                aggregators: [
                   
                    new Slick.Aggregators.Sum('Total'),
                    new Slick.Aggregators.Sum('PayVatAmount')
                   
                ]

                

            });     
            return grid;
        }

        protected createQuickSearchInput() {
        }

        protected getColumns() {
            var columns = super.getColumns();

            return columns;
        }

        protected usePager() {
            return false;
        }
    }
}